"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TRANSLATION = exports.SIZES = exports.ICON = exports.FIELDS = exports.DISPLAY = exports.COLORS = void 0;
var TRANSLATION = {
  cardTitle: 'Passport',
  lastName: 'Last name',
  firstMiddleName: 'First & middle name'
};
exports.TRANSLATION = TRANSLATION;
var FIELDS = [{
  label: TRANSLATION.lastName,
  value: 'Hemsworth'
}, {
  label: TRANSLATION.firstMiddleName,
  value: 'John'
}];
exports.FIELDS = FIELDS;
var ICON = 'Person';
exports.ICON = ICON;
var COLORS = {
  greyDarker: 'greyDarker',
  greyDark: 'greyDark',
  secondaryBlue: 'secondaryBlue'
};
exports.COLORS = COLORS;
var SIZES = {
  small: 'small',
  default: 'default',
  titleExtraLarge: 'titleExtraLarge'
};
exports.SIZES = SIZES;
var DISPLAY = {
  inlineFlex: 'inlineFlex'
};
exports.DISPLAY = DISPLAY;